export const combineValidateRules = (
  rules: Array<(value: string) => string | Promise<string>>
): ((value: string) => Promise<string>) => {
  return async (value) => {
    if (!rules.length) {
      return ''
    }

    const result = await Promise.all(
      rules.map((checkFn) => {
        return checkFn(value)
      })
    )
    return result.find((m) => m.length) || ''
  }
}
